import React, { Component } from 'react'
import { FaRegCalendarCheck, FaPhone } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import uberEatsLogo from '../images/uberEats_logo.png'
import googleMapLogo from '../images/googleMap_logo.png'
import instagramLogo from '../images/instagram_logo.png'
export default class Footer extends Component {


    render() {
        return (
            <>

                <footer className="footer">
                    <div className="footer-tel">
                        <span><FaPhone size={17} /></span>
                        <a href="tel:5196422558" className="phoneNum"><b>519.642.2558</b></a>
                    </div>
                    <div className="footer-icon-container" >
                        <a href="https://www.instagram.com/ozenlondon/">
                            <img src={instagramLogo} alt="Instagram" className="footer-icon" a="" />
                        </a>
                        <a href="https://www.ubereats.com/en-CA/london-ont/food-delivery/ozen-sushi/yCgRS0Q7S_Wlx8Flww4rWQ/">
                            <img src={uberEatsLogo} alt="UberEats" className="footer-icon" a="" />
                        </a>
                        <a href="https://www.google.ca/maps/place/O'Zen/@42.9907806,-81.2531443,17z/data=!3m1!4b1!4m5!3m4!1s0x882ef201edc2af57:0x77b4f93af4e217e7!8m2!3d42.9907806!4d-81.2509556">
                            <img src={googleMapLogo} alt="GoogleMap" className="footer-icon" a="" />
                        </a>
                    </div>
                </footer>
            </>
        )
    }
}
